/* eslint-disable @typescript-eslint/no-explicit-any */
import { Routes, Route, Navigate } from "react-router-dom";
import { useState, useEffect, lazy, Suspense } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";

//Font-end
import { PageNotFound } from "./pages/404Page";
import { PageLayout } from "./components/PageLayout";
import { TimeInOutInfo } from "./pages/font-end/TimeInOutInfo";
import { SalaryRequest } from "./pages/font-end/SalaryRequest";
import { Home } from "./pages/font-end/Home";
import { Anouncement } from "./pages/font-end/Anouncement";
import { AnouncementDetail } from "./pages/font-end/AnouncementDetail";

//Check Time Login
import IdleTimeOutHandler from "./components/IdleTimeOutHandler";

//Backoffice
import { Authen } from "./pages/backend/Authen";
import Protected from "./Protected";
import {
  getUserSalaryGroup,
  getUserSupperAdminHrmibleGroup,

} from "./services/PermissionGroup";
import { Service } from "./pages/font-end/Service";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";

// TODO: Consider refactoring App.tsx to use UserContext instead in a future update
import { getInfoUsers } from "./services/ApiGetUserInfo";

import withClearCache from "./ClearCache";
import { UserProvider } from './context/UserContext';
import { ConsentModal } from './modal/frontend/ConsentModal';
import { GetUserConsent } from './services/ApiConsent';
import { GetActivePurposes } from './services/ApiConsent';
import { AccessErrorPage } from './pages/AccessErrorPage';
import {
  AccessError,
  accessErrorFromApi,
  readLoginError, isTransientApiError } from './helpers/accessError';

// Shown while a lazily loaded back-office page is downloading.
const PageLoading = () => (
  <div className="layout-loading">
    <div className="lds-ring">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
);

//Backoffice pages
// Loaded only when an admin opens them, so employees do not download the back-office pages and their
// charting/Excel libraries on the first load.
const Dashboard = lazy(() => import("./pages/backend/Dashboard").then((m) => ({ default: m.Dashboard })));
const SuperAdmin = lazy(() => import("./pages/backend/SuperAdmin").then((m) => ({ default: m.SuperAdmin })));
const PermissionGroupMenu = lazy(() => import("./pages/backend/PermissionGroupMenu"));
const Schedulers = lazy(() => import("./pages/backend/Schedulers").then((m) => ({ default: m.Schedulers })));
const Salary = lazy(() => import("./pages/backend/Salary").then((m) => ({ default: m.Salary })));
const Annoucement = lazy(() => import("./pages/backend/Annoucement").then((m) => ({ default: m.Annoucement })));
const Payroll = lazy(() => import("./pages/backend/Payroll").then((m) => ({ default: m.Payroll })));
const UseDesktop = lazy(() => import("./pages/backend/useDesktop").then((m) => ({ default: m.UseDesktop })));

// A network blip or a single 5xx should not lock the user out: try once more before showing an error.
const getInfoUsersWithRetry = () =>
  getInfoUsers().catch((error: any) =>
    isTransientApiError(error)
      ? new Promise((resolve) => setTimeout(resolve, 1500)).then(() => getInfoUsers())
      : Promise.reject(error)
  );

const Pages = (props: any) => {
  const [infoUsers, setInfoUsers] = useState(true);
  const [showConsentModal, setShowConsentModal] = useState(false);
  const [accessError, setAccessError] = useState<AccessError | null>(null);

  useEffect(() => {
    (async () => {
      try {
        localStorage.setItem("Language", "th");
        // display modal if user has never given consent or version of consent is updated
        const adminUris = ["backoffice", "superadmin"];

        const isAdminPanel = adminUris.some((uri) =>
          window.location.pathname.includes(`/${uri}`)
        );
        
        // Temporarily always show consent modal for testing
        // setShowConsentModal(true);


        //console.info("isAdminPanel", isAdminPanel);

        if (isAdminPanel) return;
        let infoUser;
        try {
          infoUser = await getInfoUsersWithRetry();
        } catch (error) {
          const blocked = accessErrorFromApi(error);
          if (blocked) {
            setAccessError(blocked);
            return;
          }
          throw error;
        }
        const checkPath = window.location.pathname.includes("service");
        if (infoUser?.codComp1 === "PST" && !checkPath) {
          setInfoUsers(false);
          return (window.location.href = window.location.origin + "/service");
        }

        // Check user consent status
        const [userPurposesAgreement, activePurposes] = await Promise.all([
          GetUserConsent({ idOrEmail: infoUser?.email }),
          GetActivePurposes(),
        ]);
        const activePurposesRes = activePurposes || [];
        const userPurposes = userPurposesAgreement?.content[0]?.Purposes || [];

        const matchedPurposes = [];
        let hasNewVersion = false;

        // Check for matching purposes
        for (const apr of activePurposesRes) {
          const matchedPurpose = userPurposes?.find(
            (up: any) => apr?.purposeId === up?.Id
          );
          matchedPurpose && matchedPurposes.push(matchedPurpose);
        }

        // Check for version changes
        for (const apr of activePurposesRes) {
          hasNewVersion = userPurposes?.some(
            (up: any) =>
              apr?.purposeId === up?.Id && apr?.version !== up?.Version
          );
          if (hasNewVersion) {
            break;
          }
        }

        // Check if there are any new purposes
        const hasNewPurpose =
          activePurposesRes?.length !== matchedPurposes?.length ? true : false;

        // Show consent modal if needed
        if (!userPurposes?.length || hasNewPurpose || hasNewVersion) {
          setShowConsentModal(true);
        }

      } catch (error) {
        console.log(error);
      }
    })();
  }, [infoUsers]);

  if (accessError) return <AccessErrorPage error={accessError} />;

  return (
    <>
      <ConsentModal 
        showModal={showConsentModal}
        hideModal={() => setShowConsentModal(false)}
      />

      {!infoUsers && (
        <>
          <Routes>
            <Route path="/service" element={<Service />} />
          </Routes>
        </>
      )}

      {infoUsers && (
        <Suspense fallback={<PageLoading />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/time_in_out/:id" element={<TimeInOutInfo />} />
            <Route path="/salary" element={<SalaryRequest />} />
            <Route path="/anouncement" element={<Anouncement />} />
            <Route path="/service" element={<Service />} />
            <Route path="/anouncement/:id" element={<AnouncementDetail />} />
            
            {/* Redirect routes for admin panels without trailing slash */}
            <Route path="/superadmin" element={<Navigate to="/superadmin/" replace />} />
            <Route path="/backoffice" element={<Navigate to="/backoffice/" replace />} />
            
            <Route
              path="/superadmin/"
              element={
                <Protected isAdmin={props.isAdmin} role="superadmin" isCheckingPermission={props.isCheckingPermission}>
                  <SuperAdmin />
                </Protected>
              }
            />
            <Route
              path="/superadmin/PermissionGroupMenu"
              element={
                <Protected isAdmin={props.isAdmin} role="superadmin" isCheckingPermission={props.isCheckingPermission}>
                  <PermissionGroupMenu />
                </Protected>
              }
            />
            <Route
              path="/backoffice/"
              element={
                <Protected isAdmin={props.isAdmin} role="backoffice" isCheckingPermission={props.isCheckingPermission}>
                  <Dashboard />
                </Protected>
              }
            />
            <Route
              path="/backoffice/schedulers"
              element={
                <Protected isAdmin={props.isAdmin} role="backoffice" isCheckingPermission={props.isCheckingPermission}>
                  <Schedulers />
                </Protected>
              }
            />
            <Route
              path="/backoffice/Salary"
              element={
                <Protected isAdmin={props.isAdmin} role="backoffice" isCheckingPermission={props.isCheckingPermission}>
                  <Salary />
                </Protected>
              }
            />
            <Route
              path="/backoffice/anouncement"
              element={
                <Protected isAdmin={props.isAdmin} role="backoffice" isCheckingPermission={props.isCheckingPermission}>
                  <Annoucement />
                </Protected>
              }
            />
            <Route
              path="/backoffice/payroll"
              element={
                <Protected isAdmin={props.isAdmin} role="backoffice" isCheckingPermission={props.isCheckingPermission}>
                  <Payroll />
                </Protected>
              }
            />
            <Route
              path="/desktop-olny"
              element={
                <Protected isAdmin={props.isAdmin} role="backoffice" isCheckingPermission={props.isCheckingPermission}>
                  <UseDesktop />
                </Protected>
              }
            />
      
            <Route path="*" element={<PageNotFound />} />
            <Route path="/auth/:role" element={<Authen />} />
          </Routes>
        </Suspense>
      )}
    </>
  );
};
const Login = () => {
  const { instance } = useMsal();
  // A failed redirect sign-in comes back here; show why instead of redirecting to Microsoft again in a loop.
  const loginError = readLoginError();

  // Side effects belong in an effect: calling them while rendering made React warn about updating MsalProvider
  // during render and could start the redirect more than once.
  useEffect(() => {
    if (loginError) return;
    localStorage.clear();
    instance.loginRedirect(loginRequest).catch(() => undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loginError) return <AccessErrorPage error={loginError} />;
  return (
    <>
      <div className="layout-loading">
        <div className="lds-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </>
  );
};

const App = () => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [isLogout, setLogout] = useState(false);
  const [isCheckingPermission, setIsCheckingPermission] = useState(true);
  const hostname: string = window.location.pathname;

  // เรียก getUserSalaryGroup ครั้งแรกหลัง login (หรือ mount)
  useEffect(() => {
    getUserSalaryGroup().then(() => {
      // ไม่ต้อง setIsAdmin ที่นี่ ให้ logic เดิมจัดการต่อ
    });
  }, []);

  // Use an effect for permission check to avoid multiple unnecessary checks
  useEffect(() => {
    let isMounted = true;
    
    const checkPermission = async () => {
      try {
        // รอให้ usergroup โหลดเสร็จก่อน (สำหรับกรณี bookmark)
        let userGroup = sessionStorage.getItem('usergroup');
        let attempts = 0;
        const maxAttempts = 20; // รอสูงสุด 10 วินาที
        
        while (!userGroup && attempts < maxAttempts && isMounted) {
          await new Promise(resolve => setTimeout(resolve, 500));
          userGroup = sessionStorage.getItem('usergroup');
          attempts++;
        }
        
        if (!isMounted) return;
        
        // ถ้าไม่มี usergroup หลังจากรอแล้ว แสดงว่าต้อง login
        if (!userGroup) {
          setIsCheckingPermission(false);
          setIsAdmin(false);
          return;
        }
        
        // Cache permission check results to avoid redundant calls
        const permissionCacheKey = `permission_cache_${hostname}`;
        const cachedPermission = sessionStorage.getItem(permissionCacheKey);
        
        if (cachedPermission !== null && isMounted) {
          setIsAdmin(cachedPermission === 'true');
          setIsCheckingPermission(false);
          return;
        }
        
        let permission = false;
        
        if (hostname.includes("backoffice")) {
          permission = await getUserSalaryGroup();
        } else if (hostname.includes("superadmin")) {
          permission = await getUserSupperAdminHrmibleGroup();
        } else {
          permission = await getUserSalaryGroup();
        }
        
        if (!isMounted) return;
        
        // Cache the permission result
        sessionStorage.setItem(permissionCacheKey, permission ? 'true' : 'false');
        
        setIsAdmin(permission);
        setIsCheckingPermission(false);
      } catch (error) {
        console.error("Error checking permissions:", error);
        if (isMounted) {
          setIsAdmin(false);
          setIsCheckingPermission(false);
        }
      }
    };
    
    checkPermission();
    
    return () => {
      isMounted = false;
    };
  }, [hostname]);

  if (process.env.REACT_APP_ENV == "test") {
    return (
      <>
        <PageLayout>
          {/* Inside PageLayout so the profile is fetched after the access token is stored. */}
          <UserProvider>
            <Pages isAdmin={isAdmin} isCheckingPermission={isCheckingPermission} />
          </UserProvider>
        </PageLayout>
      </>
    );
  }

  return (
    <>
      <AuthenticatedTemplate>
        <PageLayout>
          <IdleTimeOutHandler
            onActive={() => {
              setIsActive(true);
            }}
            onIdle={() => {
              setIsActive(false);
            }}
            onLogout={() => {
              setLogout(true);
            }}
            timeOutInterval={process.env.REACT_APP_TIMEOUT_LOGIN} //10 minute
          />
          {/* Inside PageLayout so the profile is fetched after the access token is stored. */}
          <UserProvider>
            <Pages isAdmin={isAdmin} isCheckingPermission={isCheckingPermission} />
          </UserProvider>
        </PageLayout>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </>
  );
};

const ClearCacheComponent = withClearCache(App);

export default App;
